export default __webpack_public_path__ + "static/media/aldemat_navicon.962f5bb9.svg";